import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { Service } from './service';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule
	],
	providers: [
		Service
	]
})

export class LeafletModule {
	constructor(@Optional() @SkipSelf() parentModule: Service) {
		if (parentModule) {
			throw new Error('LeafletModule is already loaded. Import it in the AppModule only');
		}
	}

	// static forRoot(config: UserServiceConfig): ModuleWithProviders {
	// 	return {
	// 		ngModule: PapiModule,
	// 		providers: [
	// 			{provide: UserServiceConfig, useValue: config }
	// 		]
	// 	};
	// }
}
